import { JSON_HEADERS } from './constants'
import { TRIGGER_RESET_PASSWORD_ENDPOINT } from '@dtx-company/true-common/src/constants/endpoints'
import { logger } from '@dtx-company/logger'

export async function triggerResetPassword({ email }: { email: string }): Promise<string | void> {
  try {
    const res = await fetch(TRIGGER_RESET_PASSWORD_ENDPOINT, {
      method: 'POST',
      headers: JSON_HEADERS,
      body: JSON.stringify({
        email
      })
    })
    if (!res.ok) {
      await logger.logFetchError(res, { technicalArea: 'authentication' })
    }
  } catch (e: unknown) {
    logger.logError(e, { technicalArea: 'authentication' })
  }
}
